import 'next-seo';
import PropTypes from 'prop-types';

import ItemListJsonLd from 'components/Seo/ItemListJsonLd';

import { toAbsoluteLink, toStoreOffersLink } from 'lib/links';
import { formatOfferAsJsonLd } from 'lib/schemas';

import SCHEMAS from 'constants/schemas';

const CouponsSchema = ({ coupons }) => {
  const initialCoupons = coupons.slice(0, 10);

  return (
    <ItemListJsonLd
      description="Melhores cupons do momento"
      id="coupons-schema"
      items={initialCoupons}
      name="Cupons"
      renderItemAsSchema={({
        couponCode,
        storeName,
        couponDiscount,
        couponValue,
        couponUrl,
      }) =>
        formatOfferAsJsonLd({
          availability: SCHEMAS.AVAILABILITIES.LIMITED_AVAILABILITY,
          name: `Cupom ${couponCode} - ${storeName}`,
          description: `Cupom de desconto ${couponDiscount}% na ${storeName}`,
          price: couponValue,
          seller: {
            name: storeName,
            url: toAbsoluteLink(toStoreOffersLink(storeName)),
          },
          url: toAbsoluteLink(couponUrl),
        })
      }
    />
  );
};

CouponsSchema.propTypes = {
  coupons: PropTypes.arrayOf(
    PropTypes.shape({
      couponId: PropTypes.number.isRequired,
      couponDiscountValue: PropTypes.string.isRequired,
      couponDiscountShort: PropTypes.string.isRequired,
      couponDiscount: PropTypes.string.isRequired,
      couponDiscountOn: PropTypes.string.isRequired,
      couponStatusName: PropTypes.string.isRequired,
      couponInstructions: PropTypes.string.isRequired,
      couponVerified: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
      storeImage: PropTypes.string,
      storeName: PropTypes.string.isRequired,
      storeDomain: PropTypes.string.isRequired,
      storeSlug: PropTypes.string.isRequired,
      couponTag: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
      couponPublished: PropTypes.string.isRequired,
      couponTitle: PropTypes.string.isRequired,
      couponCode: PropTypes.string.isRequired,
      couponUrl: PropTypes.string.isRequired,
      userName: PropTypes.string,
    })
  ).isRequired,
};

export default CouponsSchema;
